export class PingSystem {
  constructor() {
    this.activePings = [];
  }

  createPing(type = 'danger', x = 0, z = 0, source = 'player', duration = 3.0) {
    const ping = {
      id: `ping-${Date.now()}-${Math.random()}`,
      type, // 'danger', 'on_my_way', 'missing', 'assist'
      x,
      z,
      source,
      duration,
      timer: duration
    };
    this.activePings.push(ping);
    return ping;
  }

  update(dt) {
    for (let i = this.activePings.length - 1; i >= 0; i--) {
      const p = this.activePings[i];
      p.timer -= dt;
      if (p.timer <= 0) {
        this.activePings.splice(i, 1);
      }
    }
  }
}
